// "Is the agent there?" — one honest line from the engine heartbeat and the agent watcher's beat (lib/agent.ts), shown in the
// chat panel and on the Action center's "Questions and help" tab. It refreshes on the heartbeat topic and every 15 s.
import { useEffect, useState } from "react";
import { agentPresence, type PresenceState } from "../lib/agent";
import { useLoad, useRealtime } from "../lib/hooks";
import { useApp } from "./context";

const DOT: Record<PresenceState, string> = { online: "bg-done", offline: "bg-waiting", unknown: "bg-waiting", engine_offline: "bg-blocked" };

export function AgentPresenceLine({ className = "" }: { className?: string }) {
  const { ds } = useApp();
  const hb = useLoad(() => ds.heartbeat(), [ds]);
  useRealtime(ds, "heartbeat", hb.reload);
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 15_000); return () => clearInterval(t); }, []);
  if (!hb.data && !hb.error) return <p className={`text-xs text-muted ${className}`}>Checking whether the agent is online…</p>;
  const p = hb.error ? { state: "unknown" as const, label: "Agent status unknown — the engine heartbeat could not be read", detail: hb.error } : agentPresence(hb.data ?? [], ds.mode, now);
  return (
    <p role="status" data-presence={p.state} title={p.detail} className={`flex items-start gap-1.5 text-xs text-muted ${className}`}>
      <span aria-hidden="true" className={`mt-1 inline-block h-2 w-2 shrink-0 rounded-full ${DOT[p.state]}`} />
      <span><span className="font-medium text-ink">{p.label}</span><span className="sr-only">. {p.detail}</span></span>
    </p>
  );
}
